import Config from '../Config';
import Moment from 'react-moment';
import 'moment-timezone';
import { checkInstance } from './instance';

var moment = require('moment-timezone');


class FX {
  static getBase64Image(img) {
    // Create an empty canvas element
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;

    // Copy the image contents to the canvas
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    // Get the data-URL formatted image
    // Firefox supports PNG and JPEG. You could check img.src to
    // guess the original format, but be aware the using "image/jpg"
    // will re-encode the image.
    var dataURL = canvas.toDataURL("image/png");

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  static load(app, target, callback, payload, no_wait) {
    console.log( app );
    console.log(this);
    console.log(payload);
    /*
     *
    console.log(files);

    if(0){
        var d = document.querySelectorAll('.img_new');
        for (var i = 0; i < d.length; i++){
            var formData = new FormData();
            formData.append("img[" + i + ']', files);
            var img = d[i];
            var inu = FX.getBase64Image(img);
            console.log(formData);
            console.log(inu);
        }
    }
    */


    var method = 'GET';
    var data = '';
    if(payload && payload.method){
      method = payload.method;
      data = payload.data;
    }

    if(!no_wait) app.setState({waiting: true});
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
      var DONE = 4;
      var OK = 200;
      if (xhr.readyState === DONE) {
        if(!no_wait) app.setState({waiting: false});


        if (parseInt(xhr.status, 10) === OK) {
          try{
            var res = JSON.parse(xhr.responseText);
            if(typeof callback === 'function'){
              callback(res);
            }
          }
          catch(e ) {
            console.log(e);
            console.log(xhr.responseText);
          }
        }
        else if (xhr.status) {
          // Non-200: the callback is intentionally not run (callers assume a
          // valid JSON body), but don't swallow it silently — a failed request
          // here (e.g. a 400 from product_lookup when customer_id is missing)
          // otherwise vanishes with no trace and leaves callers hanging.
          console.error('FX.load request failed', method, target, '->', xhr.status, xhr.responseText);
        }
      };
    }
    if(target.substr(0,4) === 'http'){
        console.log(target);
        xhr.open(method, target);
    }
    else if(target.substr(0,3) !== '|||'){
        console.log(app.paths.apiHost + '/' + target);
        xhr.open(method, app.paths.apiHost + '/' + target);
    }
    else {
        console.log( window.location.origin + '/' + target.substr(3));
        xhr.open(method, window.location.origin + '/' + target.substr(3));
    }
    xhr.setRequestHeader("X-Token-Sec", localStorage.token);
    console.log(no_wait);
    if(!no_wait) app.setState({wating:true});
    if(data){
      xhr.send(JSON.stringify(data));
    }
    else {
      xhr.send();
    }
  }
  static numberFix(value, float) {
      if(value.length && (( float !== true || (value.match(/\./g) || []).length !== 1 ) ||  (value.match(/[^0-9.]/g) || []).length )){
        if (isNaN( value )) {
          value = 0;
        }
        else {
          if(float === true){
            value = (parseFloat(value,10));
          }
          else {
            value = (parseInt(value,10));
          }
        }
      }
      return value;
  }
  static limit() {
    console.log(arguments);
    console.log(e);
    console.log(arguments.length);
    var e = arguments[arguments.length-1];
    console.log(e);
    console.log(e.target.value);
    console.log(parseInt(e.target.value,10));
    console.log(parseInt(e.target.dataset.max,10));
    console.log(!isNaN(parseInt(e.target.value,10)));
    if(parseInt(e.target.dataset.max,10) < parseInt(e.target.value,10) || (e.target.value && isNaN(parseInt(e.target.value,10)))){
      e.target.value = parseInt(e.target.dataset.max,10);
    }
    else if (e.target.value && !isNaN(parseInt(e.target.value,10))) {
      e.target.value = parseInt(e.target.value,10);
    }
    else if (e.target.value) {
      console.log('test');
      e.target.value = 0;
    }
    if(arguments.length > 1){
      if(typeof arguments[0] === 'function'){
        arguments[0](e);
      }
    }
  }
  static urlRetrieve( state ){

    console.log(this);

    console.log(window.location);

    console.log(this.props.root.state.current_customer);



    var n = window.location.pathname.split('/');
    var x = [];
    for (var i = 0; i < n.length; i++){
      if(n[i]){
        x.push(n[i]);
      }
    }
    console.log(x);
    if(0 <= Config.panels.indexOf(x[0]) && this.props.root.state.customer_id){
      state.panel = x[0];
      var found = false;
      if(x[1]){
        console.log(parseInt(x[1],10));

        this.retrieveDetail(parseInt(x[1],10));
      /*
        state.current_customer[x[0]].list.some(
        (ping) => {
          if(  parseInt(ping.id,10) ===  parseInt(x[1],10)){
            state.detail = ping;
            return found = true;
          }
          return false;
        }
        );
        */
      }

  }
 }
  static nav( panel, id){
    console.log( this );
    FX.load(this, panel + '/' + id , (res, i) => {
      console.log(res.order);
      if(res.order && res.id){
        this.props.root.setState({ detail : res.order  });
      }
    });
  }
  static navigate( panel, detail ,newPath , state, mutator, e){
    if(this.changed && this.changed.message){
      if(!window.confirm(this.changed.message)){
        return false;
      }
    }
    else if(this.changed){
      if(!window.confirm('This page has changed are you sure you wish to exit?')){
        return false;
      }
    }
    this.changed = false;
     console.log(e);
     console.log(mutator);
    //this.forceUpdate();
    console.log( this );
    console.log( state );
    if(typeof state !== 'object' || state.panel === undefined){
       if(typeof state === 'object' ){
         e = state;
         console.log(e);
       }
       if(typeof mutator === 'object' && e == undefined){
         e = mutator;
         mutator = false;
       }
       if(e &&  e.which == 2 ) {
          e.preventDefault();
          alert("middle button");
       }
       state = this.state;
    }
    state.panel = panel;
    state.detail = detail;
    // history.pushState serializes the state object and Firefox caps its size.
    // current_customer can carry the whole product catalogue (multi-MB), which
    // overflows the cap and throws NS_ERROR_ILLEGAL_VALUE — that uncaught throw
    // freezes navigation (menu/back stop working). Push a slim copy WITHOUT
    // current_customer; it stays live in component state and is restored from
    // memory on popstate (see App.onpopstate).
    var histState = Object.assign({}, state);
    delete histState.current_customer;
    try {
      window.history.pushState(histState, "", newPath);
    } catch(err) {
      console.log('pushState failed; pushing minimal state', err);
      window.history.pushState({panel: panel}, "", newPath);
    }
    if(mutator === true){
        return state;
    }
    else {
        this.setState(state);
    }
    console.log( panel );
    console.log( detail );
  }
  static pad (_int,tgtLength){
     _int = _int.toString();
     while (_int.length < tgtLength){
       _int = "0" + _int;
     }
     return _int;
  }
  static parseDate (date,tz){
      if(date && !(date instanceof Date) && typeof date === 'string'){
        var a = date.split(/[^0-9]/);
        //console.log(a);
        while( a.length < 6){
          console.log(6 - a.length )
          a.push('00');
        }
        //console.log(a);
        if(tz === 'Z'){
            //console.log('utc');
            return new Date(Date.UTC(a[0],a[1]-1,a[2],a[3],a[4],a[5] ));
        }
        else {
            //console.log('evs');
            
            var testDateUtc = moment.utc(date);
            var localDate = moment(testDateUtc).local();
            console.log('Michigan xxx');
            console.log(localDate )
            return localDate.toDate();
            //return new Date (a[0],a[1]-1,a[2],a[3],a[4],a[5] );
        }
      }
      try{
      //console.log(date.getTimezoneOffset());
      }
      catch(e){
      //console.log(e);

      }
      return date;
  }
  static formHandler (tgt, e){
		    console.log(e);
		    console.log(tgt);
		    console.log(this);
		    var state = this.state;
		    state[tgt] = e.target.value;
		    this.setState(state)
		    console.log(this.state[tgt]);
  }
  static handle (target, field, e) {
      var update = {};
      update[field] = e.target.value;
      target.setState(update);

  }
  static doFocus(sen){
		    console.log(this);
		    console.log(sen);
		    console.log(sen.focusTgt);
		     setTimeout(() => {
            if(sen.focusTgt && document.getElementById(sen.focusTgt)){
              document.getElementById(sen.focusTgt).focus();
              if(typeof document.getElementById(sen.focusTgt).setSelectionRange === 'function'){
                  document.getElementById(sen.focusTgt).setSelectionRange(0, document.getElementById(sen.focusTgt).value.length)
              }
              sen.focusTgt = '';
            }
		     }, 20);
  }
  static dateFormat (dateIn, format){
        if (dateIn == undefined || dateIn == null){
          return '';
        }
        var date = this.parseDate(dateIn);
        if (!(date instanceof Date)){
          return '';
        }
        if (isNaN(date.getTime())){
          return dateIn;
        }
        var monthNames = [
          "January", "February", "March",
          "April", "May", "June", "July",
          "August", "September", "October",
          "November", "December"
        ];

        var day = date.getDate();
        var monthIndex = date.getMonth();
        var monthName = monthNames[date.getMonth()];
        var monthNumber = date.getMonth() + 1;
        var year = date.getFullYear();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        if(!format){
          format = '{H}:{i} {d2}/{m2}/{Y}';
        }
        else if(format == 'php'){
          format = '{Y}-{m2}-{d2} {H}:{i}:{s}';
        }
        else if(format == '{U}'){
          return Math.floor(date / 1000);
        }
        return format.replace('{d}',day)
               .replace('{H}',this.pad(hour,2))
               .replace('{i}',this.pad(minute,2))
               .replace('{s}',this.pad(second,2))
               .replace('{d2}',this.pad(day,2))
               .replace('{M}',monthName)
               .replace('{m}',monthNumber)
               .replace('{m2}',this.pad(monthNumber, 2))
               .replace('{Y}',year);
  }
  static defend(e){
    e.preventDefault();
    e.stopPropagation();
  }
  // Base URL of the old PHP pages the UI links to directly (dispatch notes,
  // consignments, exports, report downloads, eBay connect). Set per instance
  // in /default/paths.json so staging/dev copies don't open live pages.
  static legacyHost(app){
    return ((app && app.paths && app.paths.legacyHost) || 'https://api.vdepot.co.uk').replace(/\/+$/, '');
  }
  static loadDefaultData(App){
    // A staging/dev page that can't load its paths.json must not sit on a blank spinner.
    if(!App.state.pathsOk){
      setTimeout(() => {
        if(!App.state.pathsOk && !App.state.blocked){
          App.setState({blocked: 'The settings file (default/paths.json) could not be loaded.'});
        }
      }, 8000);
    }
    this.load(App, '|||/default/paths.json', (ex)=> {
        // Staging/dev pages may only talk to their OWN backend. If paths.json sends
        // requests anywhere else (e.g. the live API) stop now, before any request.
        var inst = checkInstance(ex);
        if(inst.problem){
            App.setState({blocked: inst.problem, instance: inst.env});
            return;
        }
        App.paths = ex;
        App.setState({pathsOk: true, instance: inst.env});
        console.log('x');
        this.load(App, 'loginData2', (ex)=> {
            console.log(ex);
            if(ex.authenticated){
                App.setState(ex)
            }
            else{
                localStorage.token = '';
                App.setState(ex)
            }
        });
    });
  }
  static cacheProducts(App, products){
    // Merge full product objects into current_customer.products.list (dedupe by
    // id). Used by the document editors so their by-id product lookups keep
    // working now that the whole catalogue is no longer preloaded.
    var cc = App.state.current_customer;
    if(!cc.products){ cc.products = {list: []}; }
    if(!Array.isArray(cc.products.list)){ cc.products.list = []; }
    var byId = {};
    cc.products.list.forEach(p => { if(p){ byId[p.id] = p; } });
    (products || []).forEach(p => { if(p){ byId[p.id] = p; } });
    cc.products.list = Object.keys(byId).map(k => byId[k]);
    App.setState({current_customer: cc});
  }
  static hydrateProducts(App, ids, cb){
    // Load referenced products by id via the customer-scoped product_lookup
    // endpoint and merge them into products.list. Lets editors that open an
    // existing document resolve its line products without a full preload.
    // Skip ids already cached: detail views embed their line products and seed
    // them via cacheProducts() first, so without this a thousands-item delivery
    // re-fetches every product (dozens of requests, each forcing a full
    // re-render of the whole item table — the cause of the browser hang).
    var cc = App.state.current_customer || {};
    var have = {};
    ((cc.products && cc.products.list) || []).forEach(p => { if(p){ have[p.id] = true; } });
    var unique = Array.from(new Set((ids || []).map(x => parseInt(x, 10)).filter(x => x > 0)))
                      .filter(id => !have[id]);
    if(!unique.length){ if(typeof cb === 'function'){ cb([]); } return; }
    // Batch the ids: a single product_lookup?ids=... GET with hundreds of ids
    // builds an over-long URL the server rejects (surfaces as a CORS block).
    // Chunk into smaller requests, cache each as it returns, fire cb when done.
    var CHUNK = 100;
    var chunks = [];
    for(var i = 0; i < unique.length; i += CHUNK){ chunks.push(unique.slice(i, i + CHUNK)); }
    var remaining = chunks.length;
    var all = [];
    chunks.forEach((chunk) => {
      var data = {customer_id: App.state.customer_id, ids: chunk.join(',')};
      var qs = this.encodeQueryData(data, true);
      this.load(App, 'product_lookup' + qs, (res) => {
        var got = (res && res.products) ? res.products : [];
        this.cacheProducts(App, got);
        all = all.concat(got);
        remaining--;
        if(remaining === 0 && typeof cb === 'function'){ cb(all); }
      });
    });
  }
  static encodeQueryData(data,q) {
     let ret = [];
     for (let d in data) {
       ret.push(encodeURIComponent(d) + '=' + data[d]); //encodeURIComponent(data[d]));
     }
     if(q) {
      q = '?';
     }
     else {
      q = '';
     }
     return q + ret.join('&');
   }
   static ucfirst (string) {
      if (string){
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
   }
   static validateAddress(address){
     if (address){
      if( ["AO","AG","AW","SH","BS","BZ","BJ","BW","BO","BQ","BF","BI","CM","CF","KF","CG","CD","CK","CI","CW","DJ","DM","TL","GQ","ER","FJ","TF","GM","GA","GH","GD","GY","HM","HK","KI","LY","MO","MW","ML","MR","NR","AN","NU","KP","QA","RW","KN","ST","SC","SL","SB","SR","SY","TL","TG","TK","TO","TV","UG","AE","VU","YE","ZW"].indexOf(address.country_code) ===-1){
      return ((address.forename || address.surname || address.company) &&
	    (!!address.line_1) &&
	    (!!address.city) &&
	    (!!address.country_code) &&
	    (!!address.postcode))
	    }
	    else {
      return ((address.forename || address.surname || address.company) &&
	    (!!address.line_1) &&
	    (!!address.city) &&
	    (!!address.country_code))
	    
	    }
	   }
	   else {
	   
	      return false;
	   }
    }
    static postcodeFormat (postcode, country_code){
        if(postcode && typeof postcode === 'string' && country_code === "GB"){
            return postcode.replace(" ", "").substr(0, postcode.replace(" ", "").length -3);
        }
        return postcode
    }
    static phoneFormat (no){
       if(no && typeof no === "number" && no.toString().length == 10){
          no = "0" + no.toString().substr(0,4) + ' ' + no.toString().substr(4);
       }
       if(no && typeof no === "number" && no.toString().length == 12){
          no = "+" + no.toString().substr(0,2) + ' (0) ' + no.toString().substr(3,6) + ' ' + no.toString().substr(7);
       }
       return no;
     }
     static status( tgt , value ){
       var statusText = '';
       Config.options[tgt].some( stat => {
         if(stat.id == value ){
           statusText = stat.description;
           return true;
         }
       })
       return statusText;
     }
}

export default FX;



// WEBPACK FOOTER //
// ./src/functions/functions.js